import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SignupFormCardProps {
  children: ReactNode;
  showForm: boolean;
  reducedMotion: boolean;
}

export function SignupFormCard({ children, showForm, reducedMotion }: SignupFormCardProps) {
  return (
    <div
      className={cn(
        'transition-all duration-500 ease-out',
        reducedMotion && 'transition-none',
        showForm ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      )}
      aria-hidden={!showForm}
    >
      {children}
    </div>
  );
}
